import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormControl, AbstractControl, Validators } from '@angular/forms';

import { FormExpand } from 'src/app/models/form-expand';
import { FormPropertyKey } from 'src/app/models/form-property-key';

@Component({
  selector: 'app-form-expand',
  templateUrl: './form-expand.component.html',
  styleUrls: ['./form-expand.component.scss']
})
export class FormExpandComponent implements OnInit {

  FormPropertyKey = FormPropertyKey;

  @Input() formExpand:FormExpand;
  @Output() formExpandInputed:EventEmitter<FormExpand> = new EventEmitter();
  
  formGroup:FormGroup;

  isSendComplete:boolean = false;

  constructor() { }

  ngOnInit() {

    this.formGroup = new FormGroup({
      formPropertyKeys: new FormArray([])
    });

    this.updateFormPropertyKeys();
  }

  get formPropertyKeysFormArray(){
    return this.formGroup.get("formPropertyKeys") as FormArray;
  }
  formPropertyKeyFormGroup(index){
    return this.formPropertyKeysFormArray.controls[index] as FormGroup;
  }
  formPropertyKeyFormControl(index, name){
    const formGroup = this.formPropertyKeyFormGroup(index);
    return formGroup.get(name);
  }

  hasError(control:AbstractControl, validatorName){
    return control.errors ? control.errors[validatorName] as boolean : false;
  }

  // 必須チェックボックスのカスタムバリデーター
  requiredCheckboxValidator(control: AbstractControl) {
    const value = control.value;
    return value === true ? null : { required: true };
  }

  updateFormPropertyKeys(){

    // リセット
    this.formPropertyKeysFormArray.clear();

    this.formExpand.form.formPropertyKeys.forEach((formPropertyKey) => {

      let value = null;
      const validators = [];
      if(formPropertyKey.required == FormPropertyKey.RequiredTrue){
        // 単一チェックボックスの場合はカスタムバリデーターを使用
        if(formPropertyKey.inputType == FormPropertyKey.InputTypeSingleCheckbox){
          validators.push(this.requiredCheckboxValidator);
        } else {
          validators.push(Validators.required);
        }
      }

      if(formPropertyKey.inputType == FormPropertyKey.InputTypeText){
        value = formPropertyKey.defaultValue ? formPropertyKey.defaultValue : null;
        validators.push(Validators.maxLength(FormPropertyKey.InputTypeTextMaxLength));
      }
      else if(formPropertyKey.inputType == FormPropertyKey.InputTypeTextarea){
        value = formPropertyKey.defaultValue ? formPropertyKey.defaultValue : null;
        validators.push(Validators.maxLength(FormPropertyKey.InputTypeTextareaMaxLength));
      }
      else if(formPropertyKey.inputType == FormPropertyKey.InputTypeEmail){
        value = formPropertyKey.defaultValue ? formPropertyKey.defaultValue : null;
        validators.push(Validators.email);
      }
      else if(formPropertyKey.inputType == FormPropertyKey.InputTypeSelectDropdown){
        const option = formPropertyKey.options.find(option => option.isDefault == 1);
        if(option){
          value = option.value;
        }
      }
      else if(formPropertyKey.inputType == FormPropertyKey.InputTypeSingleCheckbox){
        value = formPropertyKey.defaultValue === '1' ? true : false;
      }
      else if(formPropertyKey.inputType == FormPropertyKey.InputTypeHidden){
        value = formPropertyKey.defaultValue ? formPropertyKey.defaultValue : null;
      }

      const formPropertyKeyGroup = new FormGroup({
        value: new FormControl(value, validators),
      });

      this.formPropertyKeysFormArray.push(formPropertyKeyGroup);
    });

  }

  getFormPropertyKey(index){
    return this.formExpand.form.formPropertyKeys[index] ?? null;
  }

  done(){

    if(this.formGroup.invalid){
      return;
    }

    // formControlのvalueをformPropertyにセット
    this.formPropertyKeysFormArray.controls.forEach((control, index) => {
      const formPropertyKey = this.getFormPropertyKey(index);
      if(! formPropertyKey){
        return;        
      }
      let value = control.get("value").value;
      
      // 単一チェックボックスの場合、boolean値を文字列に変換
      if(formPropertyKey.inputType == FormPropertyKey.InputTypeSingleCheckbox){
        value = value ? '1' : '0';
      }
      
      formPropertyKey.value = value;
    });

    this.formExpandInputed.emit(this.formExpand);

    if(this.formExpand.form.sendCompleteType == 2){
      this.isSendComplete = true;
    }
  }
}
